var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 128,
    viewBox: "0 0 140 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 70,
    cy: 64,
    rx: 69.5,
    ry: 64,
    fill: "#549457"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    x: "30%",
    y: "25%",
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2233 37.9736L19.0507 45.881C21.3119 48.1654 24.9969 48.1842 27.2813 45.9229C27.4666 45.7394 27.6394 45.5437 27.7985 45.3371L49.9809 16.5252C50.8232 15.4312 50.6191 13.8615 49.5251 13.0192C48.4311 12.1769 46.8614 12.381 46.0191 13.475L23.8366 42.2869C23.4419 42.688 22.9227 42.6854 22.6041 42.3635L14.7767 34.4561C13.8054 33.4748 12.2225 33.4668 11.2412 34.4381C10.26 35.4094 10.2519 36.9923 11.2233 37.9736Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.083ae821a4df602067d6d95dd6706ff8.svg";
export { ForwardRef as ReactComponent };